import { ColorTokenProp } from '../theme/tokens/color';

export const getColorTokenValue = (
  token: ColorTokenProp | string | undefined
): string | undefined => {
  if (!token) return undefined;
  if (typeof token === 'string') return token;
  if (typeof token === 'object' && !Array.isArray(token)) {
    const tokenObj = token as Record<string, string | undefined>;
    return tokenObj['0'] ?? tokenObj.tablet ?? tokenObj.desktop;
  }
  return undefined;
};

const COLOR_TOKEN_TO_TAILWIND_MAP: Record<string, string> = {
  defaultText: 'text-black',
  secondaryText: 'text-text',
  white: 'text-white',
  black: 'text-black',
  brand: 'text-spearmint',
  inlineAnchor: 'text-navy'
};

export const getTextColorClass = (
  colorToken: ColorTokenProp | string | undefined,
  fallback = 'text-black'
): string => {
  const tokenValue = getColorTokenValue(colorToken);
  if (!tokenValue) return fallback;

  return COLOR_TOKEN_TO_TAILWIND_MAP[tokenValue] || fallback;
};
